import { render } from "./EditProdukData.vue?vue&type=template&id=55768208"
import script from "./EditProdukData.vue?vue&type=script&lang=js"
export * from "./EditProdukData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__